import React from "react";

const TaskListSection = ({ icon, title, subTitle, value, tickIcon, onClick }) => {
  const lower = (title || "").toLowerCase();

// Hardcoded icon overrides disabled — using the API-provided `icon` as-is instead.
// // Sleep (Quality Sleep, Avg. Sleep)
// if (lower.includes("sleep")) {
//   icon = "https://appcdn.goqii.com/storeimg/50895_1764224795.png";
// }
// // Food (Eat Mindfully, Food Logs)
// else if (
//   lower.includes("eat mindfully") ||
//   lower.includes("food logs") ||
//   lower.includes("food log")
// ) {
//   icon = "https://appcdn.goqii.com/storeimg/93579_1764224769.png";
// }
// // Hydration (Stay Hydrated, Hydration)
// else if (
//   lower.includes("stay hydrated") ||
//   lower.includes("hydration") ||
//   lower.includes("hydrated")
// ) {
//   icon = "https://appcdn.goqii.com/storeimg/9676_1764224718.png";
// }
// // Steps
// else if (lower.includes("steps") || lower === "steps") {
//   icon = "https://appcdn.goqii.com/storeimg/73972_1764224823.png";
// }
// // Activity (Do Activity, Activity)
// else if (
//   lower.includes("do activity") ||
//   lower === "activity" ||
//   lower.includes("activity")
// ) {
//   icon = "https://appcdn.goqii.com/storeimg/45598_1764224847.png";
// }
// // Meditation (Do Meditation, Meditation)
// else if (lower.includes("meditate") || lower.includes("meditation")) {
//   icon = "https://appcdn.goqii.com/storeimg/45598_1764224847.png";
// }
// // Habits / Habit (Follow Habits, Follow Habit, Habit)
// else if (
//   lower.includes("follow habits") ||
//   lower.includes("follow habit") ||
//   lower.includes("habit")
// ) {
//   icon = "https://appcdn.goqii.com/storeimg/40911_1764227123.png";
// }
  const completed = tickIcon && tickIcon.trim() !== "";

  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: "45px",
        background: tickIcon ? "#f2ffcc" : "#fff",
        borderRadius: "50px",
        padding: "24px 16px",
        boxSizing: "border-box",
        marginBottom: "5px",
        marginTop: "5px",

        transition: "0.2s ease",
        gap: "16px",
        cursor: onClick ? "pointer" : "default"
      }}
    >
      {/* LEFT - Improved spacing */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          flex: 1,
          minWidth: 0
        }}
      >
        <img
          src={icon}
          alt={title}
          style={{
            width: 22,
            height: 22,
            objectFit: "contain"
          }}
        />
        <div
          style={{
            minWidth: 0,
            flex: 1
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: 600,
              color: "#4d4d4d",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {title}
          </div>
          <div
            style={{
              fontSize: "8px",
              color: "#4d4d4d",
              marginTop: 4,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {subTitle}
          </div>
        </div>
      </div>

      {/* RIGHT - Improved layout */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          flexShrink: 0
        }}
      >
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#4d4d4d",
            textAlign: "right",
            whiteSpace: "nowrap"
          }}
          dangerouslySetInnerHTML={{
            __html: value.replace(/<font[^>]*>|<\/font>/g, "")
          }}
        />

        {tickIcon && (
          <img
            src={"https://appcdn.goqii.com/storeimg/76733_1764227088.png"}
            alt="Completed"
            style={{
              objectFit: "contain",
              width: 22,
              height: 22
            }}
          />
        )}
      </div>
    </div>
  );
};

export default TaskListSection;